<!--带列表的文章-->
<template>
    <div>
        <!--顶部搜索-->
        <el-row>
            <el-form :size="size" :model="queryInfo" label-width="90px">
                <el-row :gutter="20" >
                    <el-col :span="4">
                        <el-form-item label="关键字：" >
                            <el-input :size="size" v-model="queryInfo.title" placeholder="请输入关键字" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="lunbolist.indexOf(type) != -1">
                        <el-form-item label="轮播：" >
                            <el-select v-model="queryInfo.carouselFlag" placeholder="请选择" clearable>
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="laiyuanlist.indexOf(type) != -1">
                        <el-form-item label="来源：" >
                            <el-select v-model="queryInfo.copyFrom" placeholder="请选择" clearable>
                                <el-option
                                        v-for="item in copyFroms"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="type==='gcal'">
                        <el-form-item label="厨房："  prop="houseTypeC">
                            <el-select v-model="queryInfo.houseTypeC" placeholder="选择厨房" clearable>
                                <el-option
                                        v-for="item in houseTypes"
                                        :key="item.value"
                                        :label="item.label+'厨'"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="type==='gcal'">
                        <el-form-item label="卧室："  prop="houseTypeC">
                            <el-select v-model="queryInfo.houseTypeS" placeholder="选择卧室" clearable>
                                <el-option
                                        v-for="item in houseTypes"
                                        :key="item.value"
                                        :label="item.label+'室'"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="type==='gcal'">
                        <el-form-item label="客厅："  prop="houseTypeT">
                            <el-select v-model="queryInfo.houseTypeT" placeholder="选择客厅" clearable>
                                <el-option
                                        v-for="item in houseTypes"
                                        :key="item.value"
                                        :label="item.label+'厅'"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="type==='gcal'">
                        <el-form-item label="卫生间："  prop="houseTypeW">
                            <el-select v-model="queryInfo.houseTypeW" placeholder="选择卫生间" clearable>
                                <el-option
                                        v-for="item in houseTypes"
                                        :key="item.value"
                                        :label="item.label+'卫'"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-if="type==='gcal'">
                        <el-form-item label="最大面积：" >
                            <el-input :size="size" v-model="queryInfo.maxarea" placeholder="请输入最大面积" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-if="type==='gcal'">
                        <el-form-item label="最小面积：" >
                            <el-input :size="size" v-model="queryInfo.minarea" placeholder="请输入最小面积" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <!--icon="el-icon-plus" -->
                        <el-button :size="size" :v-permission="queryPers" type="primary" @click="handleQuery">搜索</el-button>
                    </el-col>
                    <el-col :span="addSpan" style="text-align: right;" >
                        <!--icon="el-icon-plus" -->
                        <el-button :size="size" :v-permission="addPers" type="primary" @click="showAddDialog">添加{{this.title}}</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-row>
        <!--内容展示-->
        <el-row style="">
            <!--树形表格 class="treetable"-->
            <el-table ref="tableRef" border stripe :height="treeTableHeight" :data="tablelist" >
                <template v-for="(v,k) in columns">
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.label==='操作'">
                        <template slot-scope="scope">
                            <el-button :v-permission="editPers" type="primary" size="mini" icon="el-icon-edit" round @click="showEditDialog(scope.row)">编辑</el-button>
                            <el-button :v-permission="delPers" type="danger" size="mini" icon="el-icon-delete" round @click="deleteEditDialog(scope.row)">删除</el-button>
                            <el-button v-permission="['BUSINESS-ARTICLEPUSH-PUSH']" v-if="(type==='cjgg'||type==='zs')&&!scope.row.pushFlag" type="warning" size="mini" icon="el-icon-s-promotion" round @click="pushEditDialog(scope.row)">推送</el-button>
                            <el-button type="success" size="mini" icon="el-icon-view" round @click="showDialog(scope.row)">预览</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='carouselFlag'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.carouselFlag===true">是</span>
                            <span v-else >否</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='showFlag'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.showFlag===true">是</span>
                            <span v-else >否</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='pushFlag'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.pushFlag===true">是</span>
                            <span v-else >否</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='copyFrom'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.copyFrom==='self'">自建</span>
                            <span v-else-if="scope.row.copyFrom==='web'" >网络</span>
                            <span v-else>{{scope.row.copyFrom}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                </template>
            </el-table>
            <!--分页区域-->
            <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        </el-row>
        <div v-if="editDialogVisible">
            <el-dialog :title="titleForm"
                       width="50%"
                       @close="handleClose"
                       :visible.sync="editDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true">
                <el-form :model="editItem" :rules="formRules" ref="editFormRef" label-width="100px">
                    <el-row >
                        <el-col :span="24">
                            <el-form-item label="标题：" prop="title">
                                <el-input v-model="editItem.title"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="lunbolist.indexOf(type) != -1">
                            <el-form-item label="轮播：" prop="carouselFlag">
                                <el-select v-model="editItem.carouselFlag" placeholder="请选择">
                                    <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="laiyuanlist.indexOf(type) != -1">
                            <el-form-item label="来源："  prop="copyFrom">
                                <el-select v-model="editItem.copyFrom" placeholder="请选择">
                                    <el-option
                                            v-for="item in copyFroms"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="editItem.copyFrom==='web'">
                            <el-form-item label="网络地址：" prop="weburl">
                                <el-input v-model="editItem.webUrl"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="权重：" prop="point">
                                <el-input v-model="editItem.point"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="titleForm.indexOf('编辑')>-1">
                            <el-form-item label="展示：" prop="point">
                                <el-select v-model="editItem.showFlag" placeholder="请选择">
                                    <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="type==='gcal'">
                            <el-form-item label="选择厨房："  prop="houseTypeC">
                                <el-select v-model="editItem.houseTypeC" placeholder="请选择厨房">
                                    <el-option
                                            v-for="item in houseTypes"
                                            :key="item.value"
                                            :label="item.label+'厨'"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="type==='gcal'">
                            <el-form-item label="选择卧室："  prop="houseTypeC">
                                <el-select v-model="editItem.houseTypeS" placeholder="请选择卧室">
                                    <el-option
                                            v-for="item in houseTypes"
                                            :key="item.value"
                                            :label="item.label+'室'"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="type==='gcal'">
                            <el-form-item label="选择客厅："  prop="houseTypeT">
                                <el-select v-model="editItem.houseTypeT" placeholder="请选择客厅">
                                    <el-option
                                            v-for="item in houseTypes"
                                            :key="item.value"
                                            :label="item.label+'厅'"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="type==='gcal'">
                            <el-form-item label="选择卫生间："  prop="houseTypeW">
                                <el-select v-model="editItem.houseTypeW" placeholder="请选择卫生间">
                                    <el-option
                                            v-for="item in houseTypes"
                                            :key="item.value"
                                            :label="item.label+'卫'"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="type==='gcal'">
                            <el-form-item label="面积："  prop="area">
                                <el-input v-model="editItem.area" placeholder="请输入面积"></el-input>
                            </el-form-item>
                            <!--<el-form-item label="最大面积：" >
                                <el-input v-model="editItem.maxarea" placeholder="请输入最大面积"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="type==='gcal'">
                            <el-form-item label="最小面积：" >
                                <el-input v-model="editItem.minarea" placeholder="请输入最小面积"></el-input>
                            </el-form-item>-->
                        </el-col>
                        <el-col :span="24" >
                            <el-form-item label="缩略图：" >
                                <!--<img :src="litPic" class="image">:limit="1"
                                        :class="{hide:hideUploadIcon}" <img v-if="editItem.litPic" :src="litPic" class="image">:show-file-list="false"--->
                                <el-upload
                                        class="avatar-uploader"
                                        ref="upload"
                                        :action="''"
                                        :multiple="false"
                                        :on-change="onchange"
                                        list-type="picture-card"
                                        :file-list="filelists"
                                        :auto-upload="false">
                                    <!--<i class="el-icon-plus"></i>-->
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" >
                                        <span class="el-upload-list__item-actions">
                                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)" >
                                            <i class="el-icon-zoom-in"></i>
                                        </span>
                                    </span>
                                    </div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row  v-if="addshow&&editItem.copyFrom==='self'">
                        <el-col :span="24">
                            <tinymce v-model="editItem.content" @onClick="editFun" />
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer" v-if="!addshow||editItem.copyFrom==='web'">
                  <el-button type="primary" @click="editFun('')">提 交</el-button>
                </span>
            </el-dialog>
        </div>

        <el-dialog :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <div v-if="drawer">
            <el-dialog
                    title="请用手机扫码查看"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :destroy-on-close="true"
                    width="30%"
                    :visible.sync="drawer">
                <!--<span v-html="drawerItem.content" v-if="drawerItem.copyFrom==='self'"></span>
                <iframe v-if="drawerItem.copyFrom==='web'" width="100%" height="100%" :src="drawerItem.webUrl" frameborder="0" scrolling="auto" ref="iframeDom"></iframe>-->
<!--
                <iframe width="100%" height="100%" :src="webUrl" frameborder="0" scrolling="auto" ref="iframeDom"></iframe>
-->         <div style="text-align: center;">
                <img :src="QRImgUrl">
            </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        articlesPage, delArticle, addArticles, updateArticles,
        articleProjectsPage, updateArticleProjects, addArticleProjects, delArticleProjects,
        articlePushPage, articlePush, fileUp,getArticleById,getArticleProjects
    } from '@/api/file'
    import Tinymce from '@/components/tinymce/Tinymce'
    import Pagination from '@/components/pagination/index'
    import { mapGetters } from 'vuex'
    import QRCode from 'qrcode'
    import {validateNumber} from '@/utils/rule'
    export default {
        name: '',
        components: {Pagination, Tinymce},
        props: {
            title: {
                type: String,
                default: ''
            },
            type: {
               default : ''
            },
            addshow: {
                type: Boolean,
                default: true
            },
            col: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        data() {
            return{
                // 有title搜索项的
                // titlelist: ['gsdt','aqxz','hyzx','cjgg','wbzn','gcal','gdxx'],
                // 有轮播搜索项的
                lunbolist: ['gsdt','aqxz','cjgg','zs'],
                // 有来源搜索项的
                laiyuanlist: ['gsdt','aqxz','hyzx','cjgg','wbzn','zs'],
                options: [
                    {value: true,label:'是'},
                    {value: false,label:'否'}
                ],
                copyFroms: [
                    {value: 'self',label:'自建'},
                    {value: 'web',label:'网络'}
                ],
                houseTypes: [
                    {value: 0,label:'0'},
                    {value: 1,label:'1'},
                    {value: 2,label:'2'},
                    {value: 3,label:'3'},
                    {value: 4,label:'4'},
                    {value: 5,label:'5'}
                ],
                tablelist: [],
                /*columns: [
                    {
                        label: '标题',
                        prop: 'title',
                        fixed: 'left'
                    },{
                        label: '轮播',
                        // type: 'template',
                        prop: 'carouselFlag'
                    },{
                        label: '来源',
                        // type: 'template',
                        prop: 'copyFrom'
                    },{
                        label: '权重',
                        prop: 'point'
                    },{
                        label: '展示',
                        prop: 'showFlag'
                    },{
                        label: '创建时间',
                        prop: 'createTime'
                    },{
                        label: '操作',
                        type: 'template',
                        template: 'action',
                        width: '360px',
                        fixed: 'right'
                    }
                ],*/
                total: 0,
                queryInfo: {
                    pagesize: 10,
                    pagenum: 1,
                    type: this.type,
                    houseTypeC: null,
                    houseTypeS: null,
                    houseTypeT: null,
                    houseTypeW: null,
                    maxarea: null,
                    minarea: null,
                    title: '',
                    carouselFlag: null,
                    copyFrom: null
                },
                editItem: {
                    title: '',
                    content: '',
                    carouselFlag: false,
                    point: 100,
                    type: this.type,
                    copyFrom: 'self',
                    webUrl: ''
                },
                titleForm: '添加' + this.title,
                editDialogVisible: false,
                litPic: null,
                drawer:false,
                webUrl:'',
                drawerItem:{},
                QRImgUrl:'',
                hideUploadIcon: true,
                dialogVisible: false,
                dialogImageUrl: '',
                filelists:[
                    {url:''}
                ],
                addPers:[
                    'BUSINESS-ARTICLE-GSDT-MANAGEPAGE',
                    'BUSINESS-ARTICLE-AQXZ-MANAGEPAGE',
                    'BUSINESS-ARTICLE-HYZX-MANAGEPAGE',
                    'BUSINESS-ARTICLE-CJGG-MANAGEPAGE',
                    'BUSINESS-ARTICLE-GDXX-MANAGEPAGE',
                    'BUSINESS-ARTICLE-HYQY-MANAGEPAGE',
                    'BUSINESS-ARTICLE-WBZN-MANAGEPAGE',
                    'BUSINESS-ARTICLE-MXGJ-MANAGEPAGE',
                    'BUSINESS-ARTICLE-FWZC-MANAGEPAGE',
                    'BUSINESS-ARTICLE-YHXY-MANAGEPAGE',
                    'BUSINESS-ARTICLE-DJFW-MANAGEPAGE',
                    'BUSINESS-ARTICLEPROJECT-SAVE',
                    'BUSINESS-ARTICLE-ZS-SAVE'
                ],
                editPers:[
                    'BUSINESS-ARTICLE-GSDT-UPDATE',
                    'BUSINESS-ARTICLE-AQXZ-UPDATE',
                    'BUSINESS-ARTICLE-HYZX-UPDATE',
                    'BUSINESS-ARTICLE-CJGG-UPDATE',
                    'BUSINESS-ARTICLE-GDXX-UPDATE',
                    'BUSINESS-ARTICLE-HYQY-UPDATE',
                    'BUSINESS-ARTICLE-WBZN-UPDATE',
                    'BUSINESS-ARTICLE-MXGJ-UPDATE',
                    'BUSINESS-ARTICLE-FWZC-UPDATE',
                    'BUSINESS-ARTICLE-YHXY-UPDATE',
                    'BUSINESS-ARTICLE-DJFW-UPDATE',
                    'BUSINESS-ARTICLE-YSZC-UPDATE',
                    'BUSINESS-ARTICLE-ZS-UPDATE',
                    'BUSINESS-ARTICLEPROJECT-UPDATE'
                ],
                delPers:[
                    'BUSINESS-ARTICLE-GSDT-DELETE',
                    'BUSINESS-ARTICLE-AQXZ-DELETE',
                    'BUSINESS-ARTICLE-HYZX-DELETE',
                    'BUSINESS-ARTICLE-CJGG-DELETE',
                    'BUSINESS-ARTICLE-GDXX-DELETE',
                    'BUSINESS-ARTICLE-HYQY-DELETE',
                    'BUSINESS-ARTICLE-WBZN-DELETE',
                    'BUSINESS-ARTICLE-MXGJ-DELETE',
                    'BUSINESS-ARTICLE-FWZC-DELETE',
                    'BUSINESS-ARTICLE-YHXY-DELETE',
                    'BUSINESS-ARTICLE-DJFW-DELETE',
                    'BUSINESS-ARTICLE-YSZC-DELETE',
                    'BUSINESS-ARTICLE-ZS-DELETE',
                    'BUSINESS-ARTICLEPROJECT-DELETE'
                ],
                queryPers:[
                    'BUSINESS-ARTICLE-GSDT-MANAGEPAGE',
                    'BUSINESS-ARTICLE-AQXZ-MANAGEPAGE',
                    'BUSINESS-ARTICLE-HYZX-MANAGEPAGE',
                    //'BUSINESS-ARTICLE-CJGG-MANAGEPAGE',
                    'BUSINESS-ARTICLEPUSH-CJGG-PAGE',
                    'BUSINESS-ARTICLEPUSH-ZS-PAGE',
                    'BUSINESS-ARTICLE-GDXX-MANAGEPAGE',
                    'BUSINESS-ARTICLE-HYQY-MANAGEPAGE',
                    'BUSINESS-ARTICLE-WBZN-MANAGEPAGE',
                    'BUSINESS-ARTICLE-MXGJ-MANAGEPAGE',
                    'BUSINESS-ARTICLE-FWZC-MANAGEPAGE',
                    'BUSINESS-ARTICLE-YHXY-MANAGEPAGE',
                    'BUSINESS-ARTICLE-DJFW-MANAGEPAGE',
                    'BUSINESS-ARTICLEPROJECT-MANAGEPAGE'
                ],
                size:this.COMMON.size,
                treeTableHeight:650
            }
        },
        methods: {
            // 关闭添加
            handleClose() {
                this.$nextTick(() => {
                    this.editItem = {
                        title: '',
                        content: '',
                        carouselFlag: false,
                        point: 100,
                        type: this.type,
                        copyFrom: 'self',
                        litPic:null
                    } // 给表单赋值
                })
                this.editDialogVisible = false
                console.log('执行重置')
            },
            showAddDialog() {
                console.log('添加'+ this.title)
                this.titleForm = '添加' + this.title
                this.editDialogVisible = true
            },
            showEditDialog(item) {
                console.log('编辑'+ this.title,item)
                if(item.type==='gcal'){
                    getArticleProjects(item.id,this.token).then(response => {
                        //console.log(response)
                        if(response.code!=200)  return this.$message.error('获取工程案例文章失败！')
                        //console.log(response)
                        this.editItem = response.data
                        //this.editItem = JSON.parse(JSON.stringify(item))
                        this.titleForm = '编辑' + this.title
                        this.editDialogVisible = true
                    })
                }else{
                    getArticleById(item.id,item.type,this.token).then(response => {
                        //console.log(response)
                        if(response.code!=200)  return this.$message.error('获取文章失败！')
                        console.log('接口获取的',response.data)
                        this.editItem = response.data
                        //this.editItem = JSON.parse(JSON.stringify(item))
                        this.titleForm = '编辑' + this.title
                        this.editDialogVisible = true
                    })
                }
            },
            async deleteEditDialog(item) {
                const confirmResult = await this.$confirm('确认删除该记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).catch(err => err)
                // 如果用户确认删除，则返回值未字符串 confirm
                // 如果用户取消了删除，则返回值未字符串 cancel
                if (confirmResult !== 'confirm') {
                    return this.$message.info('取消删除')
                }
                if(this.type==='gcal'){
                    delArticleProjects(item.id).then(response => {
                        console.log('删除'+ this.title,response)
                        if(response.code!=200){
                            return this.$message.error(response.msg)
                        }
                        this.getArticlesPage()
                        this.$message.success(response.msg)
                    })
                }else{
                    delArticle(item.id,this.type).then(response => {
                        console.log('删除'+ this.title,response)
                        if(response.code!=200){
                            return this.$message.error(response.msg)
                        }
                        this.getArticlesPage()
                        this.$message.success(response.msg)
                    })
                }
            },
            async pushEditDialog(item){
                const confirmResult = await this.$confirm('确认推送该文章/知识?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).catch(err => err)
                // 如果用户确认删除，则返回值未字符串 confirm
                // 如果用户取消了删除，则返回值未字符串 cancel
                if (confirmResult !== 'confirm') {
                    return this.$message.info('取消推送')
                }
                articlePush(item.id).then(response => {
                    if(response.code!=200)  return this.$message.error(response.msg)
                    this.getArticlesPage()
                    this.$message.success(response.msg)
                })
            },
            getArticlesPage(){
                if(this.queryInfo.title!=undefined){
                    this.queryInfo.title = this.queryInfo.title.trim()
                }
                if(this.queryInfo.maxarea!=undefined){
                    this.queryInfo.maxarea = this.queryInfo.maxarea.trim()
                }
                if(this.queryInfo.minarea!=undefined){
                    this.queryInfo.minarea = this.queryInfo.minarea.trim()
                }
                let param = {}
                param.current = this.queryInfo.pagenum
                param.size = this.queryInfo.pagesize
                if(this.type==='gcal'){
                    articleProjectsPage(param,this.queryInfo).then(response=>{
                        if(response.code!=200)
                            return this.$message.error('获取'+ this.title+'失败！')
                        console.log('获取分页'+ this.title,response)
                        this.tablelist = response.data.records
                        this.total = response.data.total
                        this.getHeight()
                    })
                }else if(this.type==='cjgg'||this.type==='zs'){
                    articlePushPage(param,this.queryInfo).then(response=>{
                        if(response.code!=200)
                            return this.$message.error('获取'+ this.title+'失败！')
                        console.log('获取分页'+ this.title,response)
                        this.tablelist = response.data.records
                        this.total = response.data.total
                        this.getHeight()
                    })
                }else{
                    articlesPage(param,this.queryInfo).then(response=>{
                        if(response.code!=200)
                            return this.$message.error('获取'+ this.title+'失败！')
                        console.log('获取分页'+ this.title,response)
                        this.tablelist = response.data.records
                        this.total = response.data.total
                        this.getHeight()
                    })
                }
            },
            /**
             * 分页组件切换分页大小事件处理
             * @param newSize
             */
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize
                this.getArticlesPage()
            },
            /**
             * 分页组件切换页事件处理
             * @param newPage
             */
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage
                this.getArticlesPage()
            },
            // 添加或编辑
            editFun(content) {
                this.editItem.content = content
                // console.log('组件按钮回传',content)
                console.log('执行'+this.titleForm,this.editItem)
                this.$refs.editFormRef.validate(async valid => {
                    if (!valid) return
                    if(this.titleForm==='添加'+this.title){
                        if(this.type==='gcal'){
                            addArticleProjects(this.editItem).then(response => {
                                if(response.code!=200){
                                    return this.$message.error(this.titleForm+'失败！')
                                }
                                this.$message.success(this.titleForm+'成功！')
                                this.editDialogVisible = false
                                this.getArticlesPage()
                            })
                        }else{
                            addArticles(this.editItem).then(response => {
                                // console.log('添加结果',response.data)
                                if(response.code!=200){
                                    return this.$message.error(this.titleForm+'失败！')
                                }
                                this.$message.success(this.titleForm+'成功！')
                                this.editDialogVisible = false
                                this.getArticlesPage()
                            })
                        }
                    }else if(this.titleForm==='编辑'+this.title){
                        if(this.type==='gcal'){
                            updateArticleProjects(this.editItem).then(response => {
                                if (response.code != 200) {
                                    return this.$message.error(this.titleForm + '失败！')
                                }
                                this.$message.success(this.titleForm + '成功！')
                                this.editDialogVisible = false
                                this.getArticlesPage()
                            })
                        }else {
                            updateArticles(this.editItem).then(response => {
                                // console.log('编辑结果',response.data)
                                if (response.code != 200) {
                                    return this.$message.error(this.titleForm + '失败！')
                                }
                                this.$message.success(this.titleForm + '成功！')
                                this.editDialogVisible = false
                                this.getArticlesPage()
                            })
                        }
                    }
                })
            },
            /*colPanduan(){
                if(this.col.length>0){
                    this.columns = this.col
                }
            },*/
            showDialog(item){
                console.log('预览',item,window.location)
                /*this.drawerItem=item*/
                if(item.copyFrom==='self'){
                    let webbaseurl=window.location.origin
                    this.webUrl=webbaseurl+'/dist/ZnArticleView.html#/article?id='+item.id+'&type='+item.type+'&token='+this.token
                }else if(item.copyFrom==='web'){
                    this.webUrl= item.webUrl
                }
                //http://admin.zhuineng.com:8091 http://admin.zhuineng.com:8091/dist/ZnArticleView.html#/article?id=268130172874821&token=865b4331a040441192544319d7e75793
                QRCode.toDataURL(
                    this.webUrl,
                    {errorCorrectionLevel:'L',margin:2,width:128},
                    (err,url)=>{
                        if(err) throw err
                        this.QRImgUrl = url
                    }
                )
                this.drawer=true
            },
            onchange(file,fileList){
                const isJPG = file.raw.type === 'image/jpeg'
                const isPNG = file.raw.type === 'image/png'
                const isLt2M = file.size / 1024 / 1024 < 2
                console.log(fileList.length)
                // this.hideUploadIcon = fileList.length >= 1
                // this.dialogVisible=true
                if (!isPNG && !isJPG) {
                    this.$message.error('上传图片只能是 JPG/PNG 格式!')
                    return false
                } else if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!')
                    return false
                } else if (isLt2M && (isPNG || isJPG)) {
                    /*var _this = this
                    var f = file.raw
                    var reader = new FileReader()
                    reader.onload = function(e) {
                        _this.file.url = e.target.result //将图片路径赋值给src
                    }
                    reader.readAsDataURL(f)*/

                    const formData = new FormData();
                    formData.set('file', file.raw)
                    formData.set('front_end','KindEditor')
                    if(this.type==='gcal'){
                        formData.set('type','articleproject')
                    }else{
                        formData.set('type','thumbnailsimgs')
                    }
                    fileUp(formData).then(response => {
                        if (response.code != 200)
                            return this.$message.error(response.msg)
                        this.editItem.litPic = response.data.src
                        this.$message.success(response.msg)
                    })
                }
            },
            handlePictureCardPreview(){
                this.dialogImageUrl = this.filelists[0].url
                this.dialogVisible = true
            },
            getHeight(){
                // this.$set(this._computedWatchers.treeTableHeight,'dirty',true)
                // console.log(this._computedWatchers.treeTableHeight.dirty)
                if(this.type==='gcal'){
                    this.treeTableHeight=window.innerHeight - 60 -55 -40 -62 -62 -32 + 'px'
                }else{
                    this.treeTableHeight=window.innerHeight - 60 -40 -55 -62 -32 + 'px'
                }
            },
            /** 搜索按钮操作 */
            handleQuery() {
                this.queryInfo.pagenum=1
                this.getArticlesPage()
            }
        },
        computed: {
            /*treeTableHeight: function () {

            },*/
            addSpan: function(){
                if(this.lunbolist.indexOf(this.type) != -1){
                    return 10
                }else if(this.laiyuanlist.indexOf(this.type) != -1){
                    return 14
                }else if(this.type==='gcal'){
                    return 12
                }
                return 18
            },
            columns: function(){
                let arr=[]
                    arr.push({
                        label: '标题',
                        prop: 'title',
                        fixed: 'left'
                    })
                if(this.lunbolist.indexOf(this.type) != -1){
                    arr.push({
                        label: '轮播',
                        // type: 'template',
                        prop: 'carouselFlag'
                    })
                }
                if(this.laiyuanlist.indexOf(this.type) != -1){
                    arr.push({
                        label: '来源',
                        // type: 'template',
                        prop: 'copyFrom'
                    })
                }
                arr.push({
                    label: '权重',
                    prop: 'point'
                })
                arr.push({
                    label: '展示',
                    prop: 'showFlag'
                })
                arr.push({
                    label: '创建时间',
                    prop: 'createTime'
                })
                arr.push({
                    label: '操作',
                    type: 'template',
                    template: 'action',
                    width: '360px',
                    fixed: 'right'
                })
                return arr
            },
            formRules: function(){
                let arr= {}
                arr.title = [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ]
                arr.area = [
                    { validator: validateNumber, trigger: 'blur' }
                ]
                return arr
            },
            ...mapGetters([
                'token'
            ])
        },
        watch:{
            'editItem.litPic': {
                handler: function () {
                    if(this.editItem.litPic!=''){
                        this.filelists.shift()
                        this.filelists[0]= {
                            url: this.COMMON.httpUrl + this.editItem.litPic
                        }
                    }
                }
            }
        },
        created() {
            // this.colPanduan()
            this.getArticlesPage()
            //let that=this
            window.addEventListener('resize', this.getHeight)
        },
        activated(){
            this.$refs.tableRef.doLayout()
        }
    }
</script>

<style scoped>
    .image {
        width: 100%;
        display: inline-block;
        height: 100px;
    }
</style>
